import { render, staticRenderFns } from "./QuoteBloc.vue?vue&type=template&id=1b17a73b"
import script from "./QuoteBloc.vue?vue&type=script&lang=js"
export * from "./QuoteBloc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports